export default __webpack_public_path__ + "static/media/rally.fd49efb1.png";